import { UrlsInput, Label, Help } from '../../input';

export const PriorityInput = ({ params, onChange }) => {
  const handleChange = (val, field) => {
    const copy = JSON.parse(JSON.stringify(params.priority || {}));
    if (!val) {
      delete copy[field];
    } else {
      copy[field] = val;
    }

    if (Object.keys(copy).length == 0) {
      onChange('priority', null);
    } else {
      onChange('priority', copy);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 600 }}>
      <UrlsInput
        label={`Only patterns`}
        help="If specified, crawler will only visit URLs that match one of these patterns"
        value={params.priority?.only}
        onChange={(val) => handleChange(val, 'only')}
      />

      <UrlsInput
        label={`Skip patterns`}
        help="If specified, crawler will never visit URLs that match one of these patterns"
        value={params.priority?.skip}
        onChange={(val) => handleChange(val, 'skip')}
      />

      <UrlsInput
        label={`High priority`}
        help="If specified, crawler will prefr to visit URLs that match one of these patterns"
        value={params.priority?.high}
        onChange={(val) => handleChange(val, 'high')}
      />

      {/*
          <pre>{JSON.stringify(params, null, 2)}</pre>
        */}
    </div>
  );
};
